
<style lang="scss">
    .iframe-im {
        padding: 0;
        margin: 0;
        border: none;
        // width: 100%;
    }
    .im-box {
        height: 100%;
    }
</style>
<template>
    <PageLayout>
        <div class="d-flex flex-column im-box">
            <iframe ref="iframe-im" :src="`${_sysConfig.im_uri}?tk=${token}`" class="flex-grow-1 iframe-im"></iframe>
            <BottomTab v-if="showBottomTab" />  
        </div>
    </PageLayout>
</template>
<script>
import Cookie from 'js-cookie';
import appConfigMixins from "@c/mixins/appConfig.mixins";
import BottomTab from "@c/layout/BottomTab";
import PageLayout from "@c/layout/PageLayout";

export default {
    mixins: [appConfigMixins],
    components:{
        PageLayout,
        BottomTab
    },
    data: () => ({
        showBottomTab: true
    }),
    created() {
        window.addEventListener('message', this.monitorImMes)
    },
    computed: {
        token() {
            let token = $app.$store.state.user.token || Cookie.get('TOKEN')
            return token || ''
        }
    },
    methods: {
        monitorImMes(e) {
            try { //im参数为json格式 如解析错误则是其他message信息 直接忽略
                const data = JSON.parse(e.data)
                if(data.source == 'IM') { //监听来源为im 路由变化
                    if(data.type == 'onRrouterChange') { //路由变化时间
                         if(data.params.to.name == 'group') { //如果进入聊天页 隐藏底栏
                            this.showBottomTab = true
                        } else {
                            this.showBottomTab = false
                        }
                    } else if(data.type == 'onToMyInfo') { //点击我的信息事件
                        this.$router.push('personalinfomation')
                    }
                }
            } catch {}
        }
    }
}
</script>